<template>
  <div
    :class="[
      'flex items-center px-ds-md py-ds-sm text-white font-bold rounded-md gap-ds-sm cursor-pointer w-max select-none',
      toggled ? 'bg-anyvan-blue-dark' : 'bg-blue-primary hover:bg-secondary'
    ]"
    @click="$emit('click')"
  >
    <slot />
    <img
      v-if="chevron"
      :class="[$style.chevron, toggled ? $style.up : $style.down]"
      src="/content-static/navigation-menu/chevron-down.svg"
      alt="chevron down"
      loading="lazy"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "NavButton",
  props: {
    chevron: {
      type: Boolean,
      default: false
    },
    toggled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
})
</script>

<style lang="scss" module>
.chevron {
  @apply mt-[3px] transition-transform duration-300;

  &.up {
    @apply -scale-y-100;
  }
  &.down {
    @apply scale-y-100;
  }
}
</style>
